export default {"src":"/_next/static/media/Integrity.4ffc3866.svg","height":160,"width":160,"blurWidth":0,"blurHeight":0};